import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandVoice, BackendQueryBrandVoiceArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const QUERY = gql`
  query BrandVoiceWithAssets($id: ID!) {
    brandVoice(id: $id) {
      ...BrandVoice
      ...BrandVoiceAssets
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

type Variables = BackendQueryBrandVoiceArgs;
type Result = BackendBrandVoice;

export const queryBrandVoiceWithAssets = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
